module.exports = __webpack_public_path__ + "static/media/real.12587ed0.png";